import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer } from 'react-router-dom'
import useComplianceStore from '../../store'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Add Leave Type loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Add Leave Type loader')

  const getStaffMembers = useComplianceStore.getState().getStaffMembers(false)

  const getStaffRoles = useComplianceStore.getState().getStaffRoles(false)

  const getPayClassifications = useComplianceStore
    .getState()
    .getPayClassifications()

  return defer({
    data: Promise.all([getStaffMembers, getStaffRoles, getPayClassifications])
      .then(() => true)
      .catch((error) => {
        logger.error('Add Leave Type Promise.all error', error)
        return false
      }),
  })
}
